var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3687 4.00119H61.1644C63.0288 3.96822 64.8405 4.62096 66.2554 5.8355C67.6703 7.05005 68.5901 8.74185 68.84 10.5897V33.6497C68.5901 35.4975 67.6703 37.1893 66.2554 38.4039C64.8405 39.6184 63.0288 40.2712 61.1644 40.2382H52.3687M29.3087 46.8268V60.0038C29.3087 62.6249 30.35 65.1387 32.2034 66.9921C34.0567 68.8454 36.5705 69.8867 39.1916 69.8867L52.3687 40.2382V4.00119H15.2093C13.6203 3.98323 12.0785 4.54012 10.8677 5.56924C9.65697 6.59837 8.85896 8.0304 8.62071 9.60146L4.07461 39.2499C3.93128 40.1942 3.99497 41.1584 4.26126 42.0756C4.52755 42.9928 4.99008 43.8412 5.61679 44.5619C6.24351 45.2826 7.01943 45.8585 7.89079 46.2495C8.76215 46.6406 9.70812 46.8376 10.6632 46.8268H29.3087Z",
    stroke: "white",
    strokeWidth: 6.58855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.bbb10b022e92d7b4032b42c3c284bf35.svg";
export { ForwardRef as ReactComponent };